import { Injectable } from '@angular/core';
import { ColDef } from 'ag-grid-community';
import {
  AccessPermissionService,
  dblclickTooltipDef,
  defaultColumn,
  DELETE_RECORD_LABEL,
  grid_widths_map,
  mainModuleName,
  rolesModuleName,
} from '@piqet-angular/shared';
import { right } from '@popperjs/core';
import { CustomFacade } from '@piqet-angular/data';
import { cloneDeep } from 'lodash';
import { NumericCellEditor } from 'libs/ui/src/lib/numeri-cell-editor/numeric-cell-editor.component';
import { getRolesAndPermission } from 'libs/shared/src/lib/service/helper.service';
import { Subject, take } from 'rxjs';
import { SwalService } from 'libs/shared/src/lib/service/swal.service';
import { GridService } from 'libs/shared/src/lib/service/grid.service';
import { ToastrService } from 'ngx-toastr';
@Injectable({
  providedIn: 'root',
})
export class CustomFillingsDataGridService {
  customFillingPayload: any;
  event: any;
  Access: any;

  editData = new Subject<[any, any, any, any]>();
  customFillingObservable$ = this.editData.asObservable();

  editFilling = new Subject<[any, any, any, any]>();
  editFillingObservable$ = this.editFilling.asObservable();

  deleteFilling = new Subject<[any, any, any]>();
  deleteFillingObservable$ = this.deleteFilling.asObservable();

  copyFilling = new Subject<[any, any, any]>();
  copyFillingObservable$ = this.copyFilling.asObservable();

  inlineEditing = new Subject<[any, any]>();
  inlineEditingObservable$ = this.inlineEditing.asObservable();
  currentRoute: string = '';

  constructor(
    private CustomFacade: CustomFacade,
    private swalService: SwalService,
    private accessService: AccessPermissionService,
    private toaster: ToastrService
  ) {}

  accessAllPermission(type: string) {
    const access =
      this.isAccess(type, 'edit') || this.isAccess(type, 'delete') || this.isAccess(type, 'create');
    return access;
  }

  getCustomFillingDataColumn(pathName?: any): ColDef[] {
    this.currentRoute = pathName;
    const colDef: ColDef[] = [];
    colDef.push({
      ...defaultColumn,
      colId: 'ProcessName',
      headerName: 'My custom filling',
      field: 'processName',
      cellRenderer: (params: any) => {
        const cellValue = params.value;
        const cellElement = document.createElement('span');
        cellElement.style.cursor = 'pointer';
        cellElement.innerHTML = `${cellValue}`;
        const checkAccess = this.isAccess(pathName, 'edit') || this.isAccess(pathName, 'view');
        if (checkAccess) {
          cellElement.title = dblclickTooltipDef;
          cellElement.style.textDecoration = 'underline';
        }
        cellElement.addEventListener('dblclick', () => {
          checkAccess &&
            this.editFilling.next([params.data, params.data.id, 'Review custom filling', pathName]);
        });
        return cellElement;
      },
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      resizable: false,
      filter: 'agTextColumnFilter',
      editable: false,
    });

    colDef.push({
      ...defaultColumn,
      colId: 'Cost per package (USD)',
      headerName: 'Cost per package (USD)',
      field: 'packageCostSum',
      width: 468,
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      resizable: false,
      filter: 'agNumberColumnFilter',
      editable: false,
    });

    {
      pathName == 'adminCustomFilling' &&
        colDef.push({
          ...defaultColumn,
          colId: 'OrganizationName',
          headerName: 'Organization name',
          field: 'organizationName',
          cellClass: 'my-permission-cursor-pointer',
          wrapText: true,
          width: 468,
          lockVisible: true,
          autoHeight: true,
          resizable: false,
          editable: false,
          filter: 'agTextColumnFilter',
        });
    }

    colDef.push({
      ...defaultColumn,
      colId: 'OwnerName',
      headerName: 'Owner',
      field: 'ownerName',
      width: 468,
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      resizable: false,
      filter: 'agTextColumnFilter',
      editable: false,
    });

    this.accessAllPermission(pathName) &&
      colDef.push({
        ...defaultColumn,
        colId: 'Actions',
        headerName: 'Actions',
        field: 'actions',
        sortable: false,
        maxWidth: grid_widths_map.sm_column_xs,
        cellClass: 'my-permission-cursor-pointer',
        cellRenderer: 'actionRenderer',
        resizable: false,
        lockVisible: true,
        lockPosition: right,
        cellRendererParams: {
          showEdit: this.isAccess(pathName, 'edit'),
          showCopy: this.isAccess(pathName, 'create'),
          showDelete: this.isAccess(pathName, 'delete'),
          value: 'customFilling',
          deleteData: (data: any, pathName: any) => {
            if (pathName == 'adminCustomFilling') {
              this.deleteCustomFillingConfirmation(
                data,
                '/AdminCustomFilling/DeleteCustomFilling',
                pathName
              );
            } else {
              this.deleteCustomFillingConfirmation(
                data,
                '/CustomFilling/DeleteCustomFilling',
                pathName
              );
            }
          },
          copyData: (data: any, pathName: any) => {
            if (pathName == 'adminCustomFilling') {
              this.copyFilling.next([data, '/AdminCustomFilling/SaveCloneFilling', pathName]);
            } else {
              this.copyFilling.next([data, '/CustomFilling/SaveCloneFilling', pathName]);
            }
          },
          editData: (data: any, pathName: any) => {
            this.editFilling.next([data, data.id, 'Review custom filling', pathName]);
          },
          copyDataEditRendarar: (data: any) => {
            return false;
          },
        },
      });

    return colDef;
  }

  isAccess = (pathName: any, type: 'view' | 'edit' | 'create' | 'delete') => {
    return pathName.includes('admin')
      ? this.accessService.hasModulePermission(
          rolesModuleName.AdministratorFilling,
          mainModuleName.projectManagementModule,
          type
        )
      : this.accessService.hasModulePermission(
          rolesModuleName.customFilling,
          mainModuleName.customModule,
          type
        );
  };

  deleteCustomFillingConfirmation(data: any, customType: any, pathName: any) {
    this.swalService.confirm('Are you sure?', DELETE_RECORD_LABEL).then(confirmed => {
      if (confirmed) {
        this.deleteFilling.next([data, customType, pathName]);
      }
    });
  }

  getPayload(searchData: any, sortColumnState?: any, event?: any) {
    if (event) {
      this.event = event;
    }
    const currentPage = this.event?.goToPage
      ? this.event.goToPage
      : this.event?.next
      ? this.event.currentPage + 1
      : this.event?.prev
      ? this.event?.currentPage - 1
      : this.event?.gridApi?.paginationGetCurrentPage() + 1;
    const pageSize = this.event?.gridApi.paginationGetPageSize();
    const startCount = pageSize * (currentPage - 1);

    const columns = this.getCustomFillingDataColumn()
      .map((item: any) => {
        return {
          searchable: true,
          name: item.colId,
          orderable: true,
          data: item.colId,
        };
      })
      .filter(value => value?.name != 'Actions');

    return (this.customFillingPayload = {
      search: {
        columnNameList: [],
        value: searchData || '',
      },
      columns: columns,
      order: [
        {
          columnName: sortColumnState?.columnName || 'processName',
          dir:
            sortColumnState?.dir[0].toUpperCase() + sortColumnState?.dir.substr(1).toLowerCase() ||
            'Desc',
        },
      ],
      start: startCount || 0,
      length: pageSize == Number(this.event?.totalRecord) ? Number('-1') : pageSize || 10,
      draw: currentPage || 1,
    });
  }

  innedGridActionAccess(fromEdit: boolean): boolean {
    return (
      (!fromEdit && this.isAccess(this.currentRoute, 'create')) ||
      (fromEdit && !this.isAccess(this.currentRoute, 'view')) ||
      (fromEdit && this.isAccess(this.currentRoute, 'edit'))
    );
  }

  getNewProcessColumns(fromEdit: boolean = false): ColDef[] {
    const colDef: ColDef[] = [];
    let newValue: any;
    let energyTypeId: any;
    let enableEditing: any;
    let resetData: any;
    colDef.push({
      ...defaultColumn,
      colId: 'process',
      headerName: 'Process',
      field: 'energyName',
      cellClass: 'my-permission-cursor-pointer',
      cellEditor: 'GridCellRendererComponent',
      maxWidth: grid_widths_map.sm_column_xl,
      minWidth: grid_widths_map.sm_column_xl,
      cellEditorParams: {
        from: 'filling',
        editData: (data: any) => {
          newValue = data.processName;
          energyTypeId = data.energyTypeId;
        },
      },
      cellRenderer: (params: any) => {
        return `<div class="truncated-text" title="${params.value}">${
          params.value ? params.value : ''
        }</div>`;
      },
      valueSetter: (params: any) => {
        const newVal = !!newValue ? newValue : 'Select process';
        const valueChanged =
          !!newValue && !resetData ? params.data[params.colDef.field] !== newVal : false;
        params.data = { ...params.data };
        if (valueChanged) {
          params.data[params.colDef.field] =
            typeof params.oldValue == 'number' ? parseFloat(newVal) : newVal;
          params.data['energyTypeId'] = energyTypeId;
          params.data['enableEditing'] = enableEditing;
          const colId = params.colDef.field;
          const nodeId = params.data.energyId;
          this.CustomFacade.checkUpdateActionFire$.pipe(take(1)).subscribe((flag: boolean) => {
            flag &&
              this.CustomFacade.updatefillingIngredientAction(
                params.data,
                'edit',
                null,
                nodeId,
                colId
              );
          });

          newValue = '';
          energyTypeId = '';
        }
        return valueChanged;
      },
      valueGetter: params => {
        return params.data.energyName;
      },
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      lockPosition: true,
      wrapHeaderText: true,
      resizable: false,
      editable: true,
      sortable: false,
    });

    colDef.push({
      ...defaultColumn,
      colId: 'amount',
      headerName: 'Amount *',
      field: 'amount',
      suppressColumnsToolPanel: true,
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      lockVisible: true,
      lockPosition: true,
      wrapHeaderText: true,
      resizable: false,
      editable: true,
      sortable: false,
      cellRendererParams: {
        edit: 'amount',
      },
      cellEditorSelector: (params: any) => {
        if (params.colDef.colId === 'amount') {
          return {
            component: NumericCellEditor,
          };
        }
        return undefined;
      },
      cellEditorParams: {
        from: 'custom-filling-amount',
      },
      valueSetter: (params: any) => {
        const newValInt = params.newValue;
        const valueChanged = !resetData && params.data.amount !== newValInt;
        params.data = { ...params.data };
        if (valueChanged) {
          params.data.amount =
            typeof params.oldValue == 'number' ? parseFloat(newValInt) : newValInt;
          params.data['enableEditing'] = enableEditing;
        }
        const colId = params.colDef.field;
        const nodeId = params.data.energyId;
        this.CustomFacade.checkUpdateActionFire$.pipe(take(1)).subscribe((flag: boolean) => {
          flag &&
            this.CustomFacade.updatefillingIngredientAction(
              params.data,
              'edit',
              null,
              nodeId,
              colId
            );
        });
        return valueChanged;
      },
    });

    this.innedGridActionAccess(fromEdit) &&
      colDef.push({
        ...defaultColumn,
        colId: 'actions',
        headerName: 'Actions',
        field: 'actions',
        sortable: false,
        maxWidth: grid_widths_map.sm_column_xs,
        cellClass: 'my-permission-cursor-pointer',
        cellRenderer: 'inlineActionButtonComponent',
        cellRendererParams: {
          showInlineEdit: true,
          showInlineCopy: true,
          showInlineDelete: true,
          from: 'customfilling',
          copyData: (data: any) => {
            this.CustomFacade.copyfillingIngredienttAction(data, 'copy');
          },
          inlineEditData: (data: any) => {
            enableEditing = data.data.enableEditing;
            resetData = data.data.resetData;
          },
          deleteInlineGrid: (data: any) => {
            this.alertConfirmation(data);
          },
        },
        lockVisible: true,
        lockPosition: right,
        resizable: false,
        pinned: right,
      });
    return colDef;
  }

  alertConfirmation(data: any) {
    this.swalService.confirm('Are you sure?', DELETE_RECORD_LABEL).then(confirmed => {
      if (confirmed) {
        this.CustomFacade.deletefillingIngredientAction(data, 'delete');
      }
    });
  }

  isEmpty(val: any) {
    if (val !== undefined || val !== null || val !== '') {
      val = val.trim();
    }
    return val === undefined || val === null || val === '';
  }
}
